const artistImages = [
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide1.webp", caption: "Kenz at Afro Sounds." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide2.webp", caption: "Osas at Afrostalgia." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide3.webp", caption: "Efosa at The AfroCollective Experience." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide4.webp", caption: "Gwamz at Afrostalgia 2." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide5.webp", caption: "Gwamz at The AfroCollective Experience." },
];

const TabletArtistSection = () => {
  return (
    <div className="home-ipad-artists">
      <div className="artist-slide-scroller">
        <div className="artist-slide-container">
          {artistImages.map((image, i) => (
            <div key={i} className={`artist-slide`}>
              <img src={image.src} alt={`home artist ${i}`} />
              <div className={`caption-container`}>
                <p>{image.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabletArtistSection;
